/* unplugin-vue-components disabled */import script from "./BindSmartkbTenantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BindSmartkbTenantModal.vue?vue&type=script&setup=true&lang=js"

import "./BindSmartkbTenantModal.vue?vue&type=style&index=0&id=ac2cc1cc&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac2cc1cc"]])

export default __exports__